import { datadogRum } from '@datadog/browser-rum';
import pkg from '../../package.json';

datadogRum.init({
    applicationId: process.env.REACT_APP_DATADOG_APPLICATION_ID || '',
    clientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN || '',
    site: 'datadoghq.com',
    service: `${
        process.env.REACT_APP_BRAND
    }-vc-platform-${process.env.REACT_APP_COUNTRY_CODE?.toLowerCase()}`,
    version: pkg.version,
    env: process.env.VERCEL_ENV || 'development',
    sessionSampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
});

export default function DatadogInit() {
    return null;
}
